export enum GeometryTypeEnum {
  Polygon = 'polygon',
  Line = 'line',
  Point = 'point',
}
